// @flow
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'share',
  icon: [
    20,
    18,
    null,
    null,
    'M14.431 7.515C9.92 7.834 7.443 9.49 7 12.483c0-4 .833-6.667 2.5-8 1.507-1.206 3.151-1.867 4.931-1.982V0l5.5 4.983-5.5 4.916V7.515zM6 3.483v2H2v10h16v-4h2v6H0v-14h6z',
  ],
})
